import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type {
  AnnouncementDetails,
  UpdateAnnouncementPayload,
} from '../model/types';

export const updateAnnouncementAPI = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdateAnnouncementPayload;
}) => {
  const response = await baseAPI.patch<AnnouncementDetails>(
    `/announcements/${id}`,
    payload,
  );
  return response.data;
};

export const useUpdateAnnouncementMutation = () => {
  return useMutation({
    mutationFn: updateAnnouncementAPI,
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ANNOUNCEMENTS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ANNOUNCEMENTS, variables.id],
      });
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        error.response?.data?.message ?? 'Failed to update announcement',
      );
    },
  });
};
